const specialDates = {
  promptsFutureDeadline: '2030-01-01',
  approvalsSkipDate: '01 January 2001',
  approvalsSkipDateISO: new Date('January 1, 2001').toISOString(),
  notificationsLaunchDate: '2019-07-08',
};

export { specialDates };
